module.exports = __webpack_public_path__ + "img/symbol-bt.51a6b8ae.png";